import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailCompanyOther = createAsyncThunk('/dashboard_detail_company_other/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/detailCompanyOtherDash/${id}`, {})
    return response.data;
})

export const dashboardDetailCompanyOtherSlice = createSlice({
    name: 'dashboard_detail_company_other',
    initialState: {
        isLoading: false,
        dashboard_detail_company_other: []
    },

    /*extraReducers: {
        [getDetailCompanyOther.pending]: state => {
            state.isLoading = true
        },
        [getDetailCompanyOther.fulfilled]: (state, action) => {
            state.dashboard_detail_company_other = action.payload.data
            state.isLoading = false
        },
        [getDetailCompanyOther.rejected]: state => {
            state.isLoading = false
        },
    }*/

    extraReducers: (builder) => {
        builder
            .addCase(getDetailCompanyOther.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDetailCompanyOther.fulfilled, (state, action) => {
                state.dashboard_detail_company_other = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getDetailCompanyOther.rejected, (state) => {
                state.isLoading = false;
            });
    }
})

export default dashboardDetailCompanyOtherSlice.reducer